__webpack_require__.p = "https://webid.cdn.garenanow.com/assets/summerholiday.df.garena.com/";